import { FC } from 'react';
import { Lead, PersonalLead } from 'models/Lead';
import { isLeadPersonal, replaceTemplatePlaceholders } from 'utils/lead';
import classNames from 'classnames';

import './ConfirmedLeadInfo.styles.scss';
import { keysToCamelCase } from 'utils';

type ConfirmedLeadInfoProps = {
  lead: Lead | PersonalLead;
};

const stripHtml = (html: string) => {
  const div = document.createElement('div');
  div.innerHTML = html;
  return div.textContent || div.innerText || '';
};

const ConfirmedLeadInfo: FC<ConfirmedLeadInfoProps> = ({ lead }) => {
  const leadInfo = isLeadPersonal(lead) ? lead : lead?.contact;
  const { email, firstOutreach, firstSubject, firstName, lastName } =
    keysToCamelCase(leadInfo) as any;

  const messageText = stripHtml(
    replaceTemplatePlaceholders(firstOutreach, { firstName, lastName }),
  );

  return (
    <div className="lead-info">
      <h2 className="lead-info-title">Lead Details</h2>

      <div className="lead-info-section">
        <div className="lead-info-row">
          <div className="lead-info-item">
            <span className="label">First name</span>
            <span className="value">{firstName}</span>
          </div>
          <div className="lead-info-item">
            <span className="label">Last name</span>
            <span className="value">{lastName}</span>
          </div>
        </div>

        <div className="lead-info-item">
          <span className="label">Email</span>
          <span className="value">{email}</span>
        </div>

        <div className="lead-info-item">
          <span className="label">Subject</span>
          <span className="value">{firstSubject}</span>
        </div>

        <div className="lead-info-item message-field">
          <span className="label">Message</span>
          <pre className={classNames('value', 'email')}>{messageText}</pre>
        </div>
      </div>
    </div>
  );
};

export default ConfirmedLeadInfo;
